export const XingFrameQueryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'xingFrameQuery' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'webTrackingData' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'PropHashedUserId' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tracy' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'willingnessToChangeJobs',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'probability' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'networkEfficiencyIndicator' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'consumer' },
                                            value: {
                                                kind: 'StringValue',
                                                value: 'loggedin.web.wpt.topbar.neffi',
                                                block: false,
                                            },
                                        },
                                    ],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'score' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'category' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userTypeSupported' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'xingId' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'academicTitle' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'birthday' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'displayName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userFlags' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'displayFlag' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'firstName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'gender' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'globalId' },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'lastName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pageName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'profileImage' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'size' },
                                                        value: {
                                                            kind: 'ListValue',
                                                            values: [
                                                                { kind: 'EnumValue', value: 'SQUARE_128' },
                                                            ],
                                                        },
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'occupations' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'headline' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'subline' },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'features' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isXingEmployee' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isJobsPoster' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isAdmasterUser' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isBrandPageCollaborator',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isBasic' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isPremium' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isExecutive' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isSales' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hasProJobsMembership' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isCraUser' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isSeatManagerAdmin' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'showProbusinessInNavigation',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'showUpsellHint' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'showJobSeekerBoneyardUpsellHint',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'showPremiumBoneyardUpsellHint',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hasCoachProfile' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isBrandManagerEditor' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'loginState' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
//# sourceMappingURL=xingFrameQuery.gql-types.js.map